import React, { useEffect, useState, useCallback } from "react";
import style from "./block.module.scss";
import apiFetch from '@wordpress/api-fetch';
import useMedia from 'use-media';
import { Collapse } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function Block({offres, setOffres, lang}){
    const {t} = useTranslation();

    const [data, setData] = useState();
    const [open, setOpen] = useState();
    const isResponsive = useMedia({maxWidth: style.tabletBreakpoint});

    const handleClick = useCallback((id) => {
        if(offres.includes(id)){
            setOffres((old) => old.filter(e => e !== id));
        }
        else{
            setOffres((old) => [id, ...old])
        }
    }, [setOffres, offres])


    useEffect(() => {
        apiFetch({ path: '/wp/v2/offre?limit=-1&_fields=title,id&orderby=title&order=asc&lang=' + lang } ).then( value => {
            setData(value);
        });
    }, [setData, lang]);



    return<div className={style.block}>
        <div className={style.container}>
            {!isResponsive ?
                <div className={style.desktopBar}>
                    {data && data.map((value,index) => 
                        <div onClick={() => {handleClick(value.id)}} key={index} href={value.link} className={offres.includes(value.id) ? style.itemActive : style.item} dangerouslySetInnerHTML={{__html:value.title.rendered}} />
                    )}

                </div>
                :
                <>
                    <div className={style.mobileBar}>
                        <div className={(1 || open) ? style.actualFocus : style.actual} onClick={() => setOpen(open === "list" ? false : "list")}>
                            {offres.length > 0 ? <>{offres.length} {t('filtre')}{offres.length > 1 && "s"} {t('sélectionné')}{offres.length > 1 && "s"}</> : t("Filtrer par")}
                        </div>
                    </div>
                    <Collapse in={open === "list"}>
                        <div className={style.list}>
                            {data && data.map((value, index) => 
                                <div onClick={() => {handleClick(value.id)}} key={index} href={value.link} className={offres.includes(value.id) ? style.itemActive : style.item} dangerouslySetInnerHTML={{__html:value.title.rendered}} />
                            )}
                        </div>
                    </Collapse>
                    </>

            }
        </div>

        
    </div>
}

export default Block;
